<template>
  <div>
    <b-modal
      id="DPRModal"
      size="lg"
      content-class="sub-menu-bg-blue-transparent dpr-modal"
      body-class="scroll-Container"
      title="Daily Productivity Report"
      hide-footer
     
      scrollable
      @show="initDPR()"
      @hidden="closeDPR()"
    >
      <b-container>
        <b-row class="p-3">
          <!-- Logistics Card -->
          <b-col>
            <b-card
              header-html="<b>Logistics</b>"
              class="modal-card-solid-blue"
              no-body
            >
              <b-form-group class="px-3 py-2">
                <label>Date *</label>
                <b-form-input
                  id="date"
                  type="date"
                  placeholder="date"
                  v-model="form.date"
                  @change="calculateJday()"
                />
              </b-form-group>

              <b-form-group class="px-3 py-2">
                <label>Vehicle *</label>
                <b-form-select v-model="form.vehicle_id">
                  <option
                    v-for="system in vehicles"
                    :key="system.id"
                    :value="system.id"
                  >
                    {{ system.vehicle_name }}
                  </option>
                </b-form-select>
              </b-form-group>

              <b-form-group class="px-3 py-2">
                <label>Location</label>
                <b-form-select
                  v-model="form.collectedLocationCountry"
                  :options="listOfCountries"
                >
                </b-form-select>
              </b-form-group>
              <b-form-group
                v-if="
                  ['United States of America', 'Canada'].includes(
                    form.collectedLocationCountry
                  )
                "
                class="px-3 py-2"
              >
                <label for="collected_locations">Collected</label>
                <multiselect
                  id="collected_locations"
                  v-model="form.collectedLocation"
                  placeholder=""
                  :close-on-select="false"
                  :disabled="formDisabledControl"
                  :multiple="true"
                  :options="getLocationOptions()"
                >
                  <template slot="selection" slot-scope="{values, isOpen}">
                    <span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                    >
                      {{ values.length }} {{ values.length > 1 ? "options" : "option" }} selected
                    </span>
                  </template>
                </multiselect>
              </b-form-group>
              <b-form-group class="px-3 py-2">
                <label>Hotel Location *</label>
                <b-form-input id="hotelLocation" v-model="form.hotelLocation" />
              </b-form-group>
              <b-form-group class="px-3 py-2">
                <label>Jday</label>
                <b-form-input
                  id="jdate"
                  v-model="form.jdate"
                  class="text-input"
                  disabled
                  :show="jdate"
                />
              </b-form-group>
            </b-card>
          </b-col>

          <!-- Crew Information Card -->
          <b-col class="xs-spacing">
            <b-card
              header-html="<b>Crew Information</b>"
              class="modal-card-solid-blue"
              no-body
            >
              <b-form-group class="px-3 py-2">
                <div id="operatorSelectionContainer" v-for="(input, index) in operatorInputs">
                  <label
                    v-if="index == 0"
                    for="operatorSelect"
                    :value="index"
                    :key="index"
                  >
                    Operator {{ index + 1 }} *
                  </label>
                  <label
                    v-else
                    for="operatorSelect"
                    :value="index"
                  >
                    Operator {{ index + 1 }}
                  </label>
                  <b-form-select
                    v-model="form['operator' + (index + 1) + '_id']"
                    :value="index"
                    id="operatorSelect"
                  >
                    <option
                      v-for="operator in operators"
                      :key="operator.id"
                      :value="operator.id"
                      :disabled="operatorDisabled(operator.id)"
                    >
                      {{ operator.name }}
                    </option>
                  </b-form-select>
                </div>
              </b-form-group>

              <div
                class="alert alert-danger"
                role="alert"
                v-if="this.numDriversError"
              >
                <small>{{ this.numDriversError }}</small>
              </div>

              <b-row class="pb-4">
                <b-col>
                  <div class="d-flex justify-content-center">
                    <b-button
                      variant="outline-success"
                      :disabled="addDriverBtnDisabled"
                      @click="addOperator()"
                    >
                      <fa :icon="['fas', 'plus']" />
                      <span class="pl-2">Operator</span>
                    </b-button>
                  </div>
                </b-col>
                <b-col>
                  <div class="d-flex justify-content-center">
                    <b-button variant="outline-danger" @click="removeDriver()">
                      <fa :icon="['fas', 'minus']" />
                      <span class="pl-2">Operator</span>
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-row class="p-3">
          <!-- Acquisition Information Card -->
          <b-col>
            <b-card
              header-html="<b>Acquisition Information</b>"
              class="modal-card-solid-blue"
              no-body
            >
              <b-row class="px-3 pt-2">
                <b-col>
                  <b-form-group>
                    <label for="collection_hours">Collection Hours</label>
                    <b-form-input
                      id="collection_hours"
                      type="number"
                      step=".5"
                      v-model.number="form.truckHours"
                      @change="collectionHoursChange()"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <label for="office_hours">Office Hours</label>
                    <b-form-input
                      id="office_hours"
                      type="number"
                      step=".5"
                      pattern="^\d*(\.\d{0,2})?$"
                      v-model="form.officeHours"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <label for="truck_hours">Truck Hours</label>
                    <b-form-input
                      id="truck_hours"
                      type="number"
                      step=".5"
                      v-model="form.newTruckHours"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="px-3 py-2" v-if="showCollectionHoursAlert">
                <b-col>
                  <div class="alert alert-warning">
                    <span>Explain collection hours less than 6.5 in comments</span>
                  </div>
                </b-col>
              </b-row>
              <!-- WEBGIS-3113 -->
              <!-- <b-row class="px-3 py-2" v-if="showTruckHoursAlert">
                <b-col>
                  <div class="alert alert-warning">
                    <span>Explain truck hours less than 6.5 in comments</span>
                  </div>
                </b-col>
              </b-row> -->
              <b-row class="px-3 py-2">
                <b-col>
                  <label for="gtps">Number of GTP's</label>
                  <b-form-select id="gtps" v-model="form.gtps">
                    <option>NA</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="px-3 py-2">
                <b-col>
                  <label for="gtps">GTP Drive By</label>
                  <b-form-select id="gtps" v-model="form.gtpsDriveBy">
                    <option>NA</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="px-3 py-2">
                <b-col>
                  <label for="gtps">GTP Name</label>
                  <b-form-input v-model="form.gtpsName" />
                </b-col>
              </b-row>
              <b-row class="px-3 pt-2 pb-3">
                <b-col>
                  <label for="road_type">Road Type</label>
                  <multiselect
                    id="road_type"
                    v-model="form.selectedRoadTypes"
                    track-by="id"
                    label="type"
                    multiple
                    placeholder=""
                    :close-on-select="false"
                    :disabled="formDisabledControl"
                    :options="roadTypes"
                  >
                    <template slot="selection" slot-scope="{values, isOpen}">
                      <span
                        class="multiselect__single"
                        v-if="values.length && !isOpen"
                      >
                        {{ values.length }} {{ values.length > 1 ? "options" : "option" }} selected
                      </span>
                    </template>
                  </multiselect>
                </b-col>
              </b-row>
            </b-card>
          <!-- Productivity/Down Time Card -->
          </b-col>
          <b-col>
            <b-card
              header-html="<b>Productivity</b>"
              class="modal-card-solid-blue"
              no-body
            >
              <b-row class="px-3 pt-2">
                <b-col>
                  <b-form-group>
                    <label for="downtimeReason"> Reason for full down day </label>
                    <b-form-select
                      id="downtimeReason"
                      v-model="form.downtimeReason"
                      :disabled="reasonDownFullDayInputDisabled"
                      :options="downtimeReasons"
                      @change="downFullDayChange()"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="px-3 pt-2">
                <b-col>
                  <b-form-group>
                    <label for="partialDowntimeReason">
                      Reason for partial down time
                    </label>
                    <b-form-select
                      id="partialDowntimeReason"
                      v-model="form.partialDowntimeReason"
                      :disabled="reasonPartialDowntimeInputDisabled"
                      :options="downtimeReasons"
                      @change="partialDowntimeReasonChange()"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="px-3 pt-2">
                <b-col>
                  <b-form-group id="numHoursPartialForm">
                    <label for="numHoursPartialDowntime">
                      Partial down time hours
                      <span v-if="form.partialDowntimeReason != null"> * </span>
                    </label>
                    <b-form-input
                      :disabled="partialDowntimeHoursDisabled"
                      type="number"
                      step=".5"
                      id="numHoursPartialDowntime"
                      v-model="form.numHoursPartialDowntime"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-row class="p-3 row">
          <!-- Issues Card -->
          <b-col>
            <b-card
              header-html="<b>Issues</b>"
              class="modal-card-solid-blue"
              no-body
            >
              <b-row class="px-3 py-2 row">
                <b-col>
                  <label for="issues">Issues</label>
                  <multiselect
                    id="issues"
                    v-model="form.selectedIssues"
                    track-by="id"
                    label="issue"
                    multiple
                    placeholder=""
                    :close-on-select="false"
                    :disabled="formDisabledControl"
                    :options="issues"
                  >
                    <template slot="selection" slot-scope="{values, isOpen}">
                      <span
                        class="multiselect__single"
                        v-if="values.length && !isOpen"
                      >
                        {{ values.length }} {{ values.length > 1 ? "options" : "option" }} selected
                      </span>
                    </template>
                  </multiselect>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <!-- Upload Image Card -->
          <b-col>
            <b-card
              header-html="<b>Upload Image</b>"
              class="modal-card-solid-blue"
              no-body
            >
              <b-row class="px-3 py-2">
                <b-col class="py-3">
                  <input
                    id="imageInput"
                    type="file"
                    ref="file"
                    multiple="true"
                    accept="image/x-png,image/jpeg"
                    @change="onImageSelected($event)"
                  />
                </b-col>
                <br /><br />
              </b-row>
              <b-row v-for="element in images" class="pl-3" :key="element.id">
                <label class="pl-3 mb-1 labels">
                  {{ element.image_path.split('\\', 2)[1] }}
                </label>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <!-- Comments Card -->
        <b-row class="p-3">
          <b-col>
            <b-card
              header-html="<b>Comments *</b>"
              class="modal-card-solid-blue"
              no-body
            >
              <b-row class="px-3 pt-3">
                <b-col>
                  <b-form-group>
                    <b-form-textarea
                      id="comments"
                      name="textarea-input"
                      rows="9"
                      v-model="form.comments"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-if="formSubmitErrors.length" id="formSubmitErrorsWindow">
          <b-col class="text-center">
            <span>
              <b>Please correct the following error(s):</b>
              <ul class="list-group">
                <div
                  class="alert alert-danger"
                  v-for="error in formSubmitErrors"
                  :key="error"
                >
                  <li class="list-group-item">{{ error }}</li>
                </div>
              </ul>
            </span>
          </b-col>
        </b-row>

        <b-row class="p-3" v-if="submitSuccess" id="submitSuccessWindow">
          <b-col class="text-center">
            <span class="alert alert-success">
              <b>{{ this.submitSuccess }}</b>
            </span>
            <span class="btn" style="color: white" @click="submitSuccessHide()">
              <fa :icon="['fas', 'window-close']" />
            </span>
          </b-col>
        </b-row>

        <b-row class="p-3" v-if="updateSuccessMsg" id="updateSuccessWindow">
          <b-col class="text-center">
            <span class="alert alert-success">
              <b>{{ this.updateSuccessMsg }}</b>
            </span>
            <span class="btn" style="color: white" @click="updateSuccessHide()">
              <fa :icon="['fas', 'window-close']" />
            </span>
          </b-col>
        </b-row>

        <b-row class="p-3" v-if="this.updateEntryID" id="updateBtns">
          <b-col>
            <b-button
              class="float-right"
              variant="primary"
              size="lg"
              type="submit"
              @click="isAdmin ? submitEntryUpdate() : checkForm()"
            >
              Update Entry
            </b-button>
          </b-col>
          <b-col>
            <b-button
              variant="secondary"
              size="lg"
              type="button"
              @click="cancelUpdate()"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
        <b-row class="p-3" v-else id="submitBtns">
          <b-col>
            <b-button
              class="float-right"
              variant="primary"
              size="lg"
              type="submit"
              @click="isAdmin ? submitForm() : checkForm()"
            >
              Submit
            </b-button>
          </b-col>
          <b-col>
            <b-button
              variant="secondary"
              size="lg"
              type="button"
              @click="clearForm()"
            >
              Clear
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
  
</template>

<style>
/* Add space between cards for mobile view */
@media (max-width: 470px) {
  .xs-spacing {
    padding-top: 2rem;
  }
}
@media (min-width: 768px) {
  .modal-xl {
    width: 95%;
    max-width: 1600px;
  }
}
.checkbox {
  width: 20px;
  height: 20px;
  margin: 0.5rem;
}
#DPRModal .modal-lg {
  max-width: 1200px !important;
}

/* ── DPR Modal theme ───────────────────────────────────── */
.dpr-modal .modal-header {
  background: #063c6d;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 12px 20px;
  border-radius: 7px 7px 0 0;
}
.dpr-modal .modal-title {
  color: #fff;
  text-shadow: none;
  font-weight: 600;
}
.dpr-modal .close {
  color: #fff;
  opacity: 0.8;
  text-shadow: none;
}

/* Cards: white background, dark blue header strip */
.dpr-modal .modal-card-solid-blue {
  background: #fff !important;
  color: #063c6d !important;
  border: 1px solid rgba(6, 60, 109, 0.15);
  border-radius: 6px;
}
.dpr-modal .modal-card-solid-blue .card-header {
  background: rgba(6, 60, 109, 0.07);
  color: #063c6d;
  border-bottom: 1px solid rgba(6, 60, 109, 0.12);
  font-weight: 600;
  font-size: 0.85rem;
}

/* Labels */
.dpr-modal label {
  color: rgba(6, 60, 109, 0.7);
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-bottom: 3px;
}

/* Inputs, selects, textarea — subtle gray */
.dpr-modal .form-control,
.dpr-modal select {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
  border-radius: 4px;
}
.dpr-modal .form-control:focus,
.dpr-modal select:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}
.dpr-modal .form-control:disabled {
  background: #e9ecef !important;
  color: rgba(6, 60, 109, 0.4) !important;
}
.dpr-modal select option {
  background: #fff;
  color: #063c6d;
}

/* Multiselect */
.dpr-modal .multiselect__tags {
  background: #f3f5f8;
  border: 1px solid rgba(6, 60, 109, 0.2);
  border-radius: 4px;
}
.dpr-modal .multiselect__input,
.dpr-modal .multiselect__single {
  background: #f3f5f8;
  color: #063c6d;
}
.dpr-modal .multiselect__content-wrapper {
  border: 1px solid rgba(6, 60, 109, 0.2);
}
.dpr-modal .multiselect__option--highlight {
  background: rgba(6, 60, 109, 0.1);
  color: #063c6d;
}
.dpr-modal .multiselect__option--selected {
  background: rgba(6, 60, 109, 0.06);
  color: #063c6d;
  font-weight: 600;
}

/* Buttons */
.dpr-modal .btn-primary {
  background: #063c6d !important;
  border-color: #063c6d !important;
  color: #fff !important;
}
.dpr-modal .btn-primary:hover {
  background: #0a5499 !important;
  border-color: #0a5499 !important;
}
.dpr-modal .btn-outline-success {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.4) !important;
}
.dpr-modal .btn-outline-success:hover {
  background: rgba(6, 60, 109, 0.08) !important;
  color: #063c6d !important;
}
.dpr-modal .btn-outline-danger {
  color: #dc3545 !important;
  border-color: #dc3545 !important;
}
.dpr-modal .btn-secondary {
  background: transparent !important;
  border-color: rgba(6, 60, 109, 0.3) !important;
  color: rgba(6, 60, 109, 0.65) !important;
}

/* Success message close button */
.dpr-modal .btn[style*="color: white"] {
  color: #063c6d !important;
}
</style>

<script>
import 'vue-date-pick/dist/vueDatePick.css'
import DatePick from 'vue-date-pick'
import Multiselect from 'vue-multiselect'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'
import fd from 'form-data'

export default {
  name: 'MMP_DPR',
  components: {
    Multiselect,
    VueBootstrap4Table,
    DatePick,
    fd
  },
  props: ['isAdmin', 'user'],
  data() {
    return {
      app: 'dpr',
      formSubmitErrors: [],
      entryManagerRows: [],
      // Numerical columns do not sort correctly
      submitSuccess: '',
      updateSuccessMsg: '',
      formDisabledControl: false,
      partialDowntimeHoursDisabled: true,
      reasonDownFullDayInputDisabled: false,
      reasonPartialDowntimeInputDisabled: false,
      possibleLocationsUSA: [
        'Alabama',
        'Alaska',
        'American Samoa',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'District of Columbia',
        'Federated States of Micronesia',
        'Florida',
        'Georgia',
        'Guam',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Marshall Islands',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Northern Mariana Islands',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Puerto Rico',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virgin Island',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
      ],
      possibleLocationsCA: [
        'Alberta',
        'British Columbia',
        'Manitoba',
        'New Brunswick',
        'Newfoundland and Labrador',
        'Northwest Territories',
        'Nova Scotia',
        'Nunavut',
        'Ontario',
        'Prince Edward Island',
        'Quebec',
        'Saskatchewan',
        'Yukon Territory'
      ],
      vehicles: [],
      downtimeReasons: [
        {value: null, text: 'NA'},
        'Collect',
        'Weather',
        'Lidar Issues',
        'Routine Maintenance',
        'Non-Routine Maintenance',
        'Mobilization',
        'Sick',
        'Travel',
        'Not Sufficient Operators',
        'PTO',
        'Holiday',
        'System Setup',
        'At Riegl',
        'No System',
        'Review',
        'DB Trail Issue',
        '3DMS Project',
        'Partial Collection'
      ],
      operators: [],
      roadTypes: [],
      issues: [
        {
          id: '1',
          issue: 'DMI'
        },
        {
          id: '2',
          issue: 'Front Camera'
        },
        {
          id: '3',
          issue: 'Rear Camera'
        }
      ],
      addDriverBtnDisabled: false,
      operatorInputs: ['1'],
      updateEntryID: null,
      maxNumDrivers: 3,
      numDriversError: '',
      showCollectionHoursAlert: false,
      form: {
        date: null,
        vehicle_id: null,
        collectedLocation: [],
        collectedLocationCountry: null,
        operator1_id: null,
        operator2_id: null,
        operator3_id: null,
        truckHours: 0, // "Collection Hours" -- WEBGIS-3097
        newTruckHours: 0, // "Truck Hours" -- WEBGIS-3097
        officeHours: 0,
        gtps: null,
        gtpsDriveBy: null,
        gtpsName: null,
        selectedRoadTypes: [],
        downtimeReason: null,
        partialDowntimeReason: null,
        numHoursPartialDowntime: 0,
        selectedIssues: [],
        comments: null,
        jdate: null,
        hotelLocation: null
      },
      bgColorChange: {
        backgroundColor: '#222222'
      },
      editBgColorChange: 'lightblue',
      jdate: null,
      listOfCountries: [
        'Austria',
        'Bahrain',
        'Belgium',
        'Canada',
        'Denmark',
        'Finland',
        'France',
        'Germany',
        'Ireland',
        'Italy',
        'Japan',
        'Kuwait',
        'Luxembourg',
        'Mexico',
        'Netherlands',
        'Norway',
        'Oman',
        'Poland',
        'Portugal',
        'Qatar',
        'Saudi Arabia',
        'Spain',
        'South Korea',
        'Sweden',
        'Switzerland',
        'UAE',
        'United Kingdom',
        'United States of America',
      ],
      selectedFile: null,
      entryFreshlyLoaded: false,
      images: [],
      backgroundColor: null
    }
  },
  methods: {
    initDPR() {
      this.getDevices()
      this.getOperators()
      this.getRoadTypes()
      this.getImageList()
    },
    // Executes when the Entry Manager button is clicked
    initEntryManager() {
      // Show modal with spinner while API call is loading
      this.$bvModal.show('entryManagerModal')
    },
    // REFACTOR: not used anywhere
    initAdminConsole() { 
      this.$bvModal.show('adminConsoleModal')
    },
    // REFACTOR: not used anywhere
    initReportConsole() {
      this.$bvModal.show('reportsModal')
    },
    // REFACTOR: not used anywhere
    closeAdminConsole() {
      this.$bvModal.hide('adminConsoleModal')
    },
    // REFACTOR: not used anywhere
    closeEntryManager() {
      this.$bvModal.hide('entryManagerModal')
    },
    loadEntryManager() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/entry_manager', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              isAdmin: this.isAdmin,
              extent: this.user.extent
            }
          })
          .then(response => {
            const content = response.data
            // If duplicate entry found, throw error and prevent submission
            if (content.errors) {
              console.log('Entry Manager API Call Error: ' + content.errors)
            } else {
              // Place retrieved data into rows display array for table
              this.entryManagerRows = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    cancelUpdate() {
      this.updateEntryID = null
      this.closeDPR()
      this.initEntryManager()
    },
    submitEntryUpdate() {
      // Clear previous success and error messages
      this.hideAllMessages()
      this.imageUpload()
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/update', {
            method: 'PUT',
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              date: this.form.date,
              vehicle_id: this.form.vehicle_id,
              collected_location: [
                'United States of America',
                'Canada'
              ].includes(this.form.collectedLocationCountry)
                ? this.form.collectedLocation
                : null,
              collected_location_country: this.form.collectedLocationCountry,
              operator1_id: this.form.operator1_id,
              operator2_id: this.form.operator2_id,
              operator3_id: this.form.operator3_id,
              truck_hours: this.form.truckHours,
              new_truck_hours: this.form.newTruckHours,
              office_hrs: this.form.officeHours,
              gtps: this.form.gtps,
              gtps_db: this.form.gtpsDriveBy,
              gtps_name: this.form.gtpsName,
              road_type: this.form.selectedRoadTypes,
              reason_dt: this.form.downtimeReason,
              reason_dt_part: this.form.partialDowntimeReason,
              num_hours_partial_dt: this.form.numHoursPartialDowntime,
              issues: this.form.selectedIssues,
              comments: this.form.comments,
              jdate: this.form.jdate,
              entry_id: this.updateEntryID,
              hotel_loc: this.form.hotelLocation
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Update Entry API Call Error: ' + content.errors)
            } else if (!content.successful) {
              this.formSubmitErrors.push(content.msg)
            } else {
              // Displays success message
              this.updateSuccessMsg = content.msg
              this.$emit('dprUpdated', content.data)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getOperators() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/getActiveOperators', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              isAdmin: this.isAdmin,
              extent: this.user.extent
            }
          })
          .then(response => {
            const content = response.data
            // If duplicate entry found, throw error and prevent submission
            if (content.errors) {
              console.log('Operator API Call Error: ' + content.errors)
            } else {
              this.operators = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    operatorDisabled(id) {
      if (
        this.form.operator1_id === id ||
        this.form.operator2_id === id ||
        this.form.operator3_id === id
      ) {
        return true
      } else {
        return false
      }
    },
    getRoadTypes() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/roadType', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            // If duplicate entry found, throw error and prevent submission
            if (content.errors) {
              console.log('Road Types API Call Error: ' + content.errors)
            } else {
              this.roadTypes = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    removeDriver() {
      // If operator input length is 1 do not perform any operation as it is a mandatory field.
      if (!this.isAdmin) {
        if (this.operatorInputs.length > 1) {
          this.removeDriverSubFunction()
        }
      } else {
        this.removeDriverSubFunction()
      }
    },
    removeDriverSubFunction() {
      if (this.operatorInputs.length == this.maxNumDrivers) {
        // If we are at max num of drivers, then we need to clear operator 3
        // and hide operator 3 input
        this.form.operator3_id = null
        this.operatorInputs.pop()
        // Clear any error
        this.numDriversError = ''
        this.addDriverBtnDisabled = false
      } else {
        // Num of driver inputs must be 2 at this point, so we need to clear driver 2
        // and hide operator 2 input
        this.form.operator2_id = null
        this.operatorInputs.pop()
      }
    },
    getDevices() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/allVehicles', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              isAdmin: this.isAdmin,
              extent: this.user.extent
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Vehicles API Call Error: ' + content.errors)
            } else {
              this.vehicles = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    checkForm() {
      this.formSubmitErrors = []
      if (!this.form.date) {
        this.formSubmitErrors.push('Date required.')
      }
      if (!this.form.vehicle_id) {
        this.formSubmitErrors.push('Vehicle required.')
      }
      if (!this.form.operator1_id) {
        this.formSubmitErrors.push('Operator 1 required.')
      }
      if (!this.form.hotelLocation) {
        this.formSubmitErrors.push('Hotel Location required.')
      }
      // If not full down days
        // if (this.form.downtimeReason === null) {
        //   // Truck hours and partial down time hours need to sum at least 6.5
        //   if (
        //     Number(this.form.truckHours) +
        //       Number(this.form.numHoursPartialDowntime) <
        //     6.5
        //   ) {
        //     this.formSubmitErrors.push(
        //       'Must have 6.5 truck Hours and/or partial DT hours.'
        //     )
        //   }
        // }
        
      // If partial down time reason selected
      if (this.form.partialDowntimeReason != null) {
        if (this.form.numHoursPartialDowntime === 0) {
          this.formSubmitErrors.push(
            'Number of partial down time hours required.'
          )
        }
      }
      if (!this.form.comments) {
        this.formSubmitErrors.push('Comments required.')
      }
      if (!this.formSubmitErrors.length) {
        if (!this.updateEntryID) {
          if (sessionStorage.token) {
            /* If there aren't any errors, run API call
            to check if this is a duplicate entry */
            axios
              .get(process.env.API_LOCATION + '/api/dpr/formDuplicateCheck', {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  vehicle_id: this.form.vehicle_id,
                  date: this.form.date
                }
              })
              .then(response => {
                // If duplicate entry found, throw error and prevent submission
                if (response.data.rowCount > 0) {
                  this.formSubmitErrors.push(
                    'Vehicle already has entry for this date.'
                  )
                }
                if (!this.formSubmitErrors.length) {
                  this.submitForm()
                }
              })
              .catch(function (error) {
                console.log(error)
              })
          } else {
            console.log('No User Token')
          }
        } else {
          this.submitEntryUpdate()
        }
      }
    },
    // REFACTOR - function not used. Also throws error - pad() is not a function -- fixed.
    // Display date as mm-dd-yyyy
    formatDateForDisplay(date) {
      if (date == null) {
        return
      }
      const newDate = new Date(date)
      return (
        (newDate.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        newDate.getDate().toString().padStart(2, '0') +
        '-' +
        newDate.getFullYear()
      )
    },
    // Date input field uses a normalized format of yyyy-mm-dd
    formatDateForField(date) {
      if (date == null) {
        return
      }
      const newDate = new Date(date)
      return (
        newDate.getFullYear() +
        '-' +
        (newDate.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        newDate.getDate().toString().padStart(2, '0') 
      ) 
    },
    downFullDayChange() {
      // If full down day field is not null, disable road type inputs
      if (this.form.downtimeReason !== null) {
        this.form.selectedRoadTypes = []
        this.form.collectedLocation = null
        this.formDisabledControl = true
        this.reasonPartialDowntimeInputDisabled = true
      } else {
        this.formDisabledControl = false
        this.reasonPartialDowntimeInputDisabled = false
      }
    },
    partialDowntimeReasonChange() {
      // If reason for partial down time input was changed back to null
      if (this.form.partialDowntimeReason === null) {
        // Reset partial down time hours and disable it
        this.form.numHoursPartialDowntime = 0
        this.partialDowntimeHoursDisabled = true
        this.reasonDownFullDayInputDisabled = false
        // Else reason for partial down time input is valid input
      } else {
        this.partialDowntimeHoursDisabled = false
        this.formDisabledControl = false
        this.reasonDownFullDayInputDisabled = true
      }
    },
    collectionHoursChange() {
      if (this.form.truckHours < 6.5) {
        this.showCollectionHoursAlert = true
      } else {
        this.showCollectionHoursAlert = false
      }
    },
    submitForm() {
      // Clear previous success messages
      this.submitSuccessHide()
      this.updateSuccessHide()
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': sessionStorage.token
            },
            params: {
              date: this.form.date,
              vehicle_id: this.form.vehicle_id,
              collected_location: this.form.collectedLocation,
              collected_location_country: this.form.collectedLocationCountry,
              operator1_id: this.form.operator1_id,
              operator2_id: this.form.operator2_id,
              operator3_id: this.form.operator3_id,
              truck_hours: this.form.truckHours,
              new_truck_hours: this.form.newTruckHours,
              office_hrs: this.form.officeHours,
              gtps: this.form.gtps,
              gtps_db: this.form.gtpsDriveBy,
              gtps_name: this.form.gtpsName,
              road_type: this.form.selectedRoadTypes,
              reason_dt: this.form.downtimeReason,
              reason_dt_part: this.form.partialDowntimeReason,
              numHoursPartialDowntime: this.form.numHoursPartialDowntime,
              issues: this.form.selectedIssues,
              comments: this.form.comments,
              jdate: this.form.jdate,
              entry_id: this.updateEntryID,
              hotel_loc: this.form.hotelLocation
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('POST Form API Call Error: ' + content.errors)
            } else {
              this.imageUpload()
              this.submitSuccess = 'Daily Productivity Report Submitted'
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
      this.loadEntryManager()
    },
    submitSuccessHide() {
      this.submitSuccess = ''
    },
    updateSuccessHide() {
      this.updateSuccessMsg = ''
    },
    hideAllSuccessMessages() {
      this.submitSuccessHide()
      this.updateSuccessHide()
    },
    hideAllErrorMessages() {
      this.formSubmitErrors = []
    },
    hideAllMessages() {
      this.hideAllErrorMessages()
      this.hideAllSuccessMessages()
    },
    clearForm() {
      this.form = {
        selectedIssues: null,
        comments: null,
        date: null,
        gtps: null,
        gtpsDriveBy: null,
        gtpsName: null,
        jdate: null,
        operator1_id: null,
        operator2_id: null,
        operator3_id: null,
        vehicle_id: null,
        numHoursPartialDowntime: 0,
        officeHours: 0,
        newTruckHours: 0,
        truckHours: 0,
        downtimeReason: null,
        partialDowntimeReason: null,
        collectedLocation: [],
        selectedRoadTypes: [],
        hotelLocation: null
      }
      this.showCollectionHoursAlert = false
      // Revert back background
      this.bgColorChange.backgroundColor = this.backgroundColor // this is not a variable -- added.
    },
    addOperator() {
      this.numDriversError = ''
      if (this.operatorInputs.length < this.maxNumDrivers) {
        this.operatorInputs.push(this.operatorInputs.length + 1)
      } else {
        this.numDriversError = 'Maximum number of Operators.'
        this.addDriverBtnDisabled = true
      }
    },
    updateEntryManager(row) {
      const entryID = row.id
      this.updateEntryID = row.id
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/entry_manager/' + entryID, {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Update Entry API Call Error: ' + content.errors)
              // Else no errors and we can load returned entry into form
            } else {
              const data = content.rows[0]
              this.entryFreshlyLoaded = true
              // Determine number of driver inputs to display
              if (data.operator1_id && data.operator2_id && data.operator3_id) {
                this.operatorInputs = ['1', '2', '3']
              } else if (data.operator1_id && data.operator2_id) {
                this.operatorInputs = ['1', '2']
              } else {
                this.operatorInputs = ['1']
              }
              this.form = {
                date: this.formatDateForField(data.date),
                vehicle_id: data.vehicle_id,
                collectedLocation: data.collected_location,
                operator1_id: data.operator1_id,
                operator2_id: data.operator2_id,
                operator3_id: data.operator3_id,
                truckHours: data.truck_hours,
                newTruckHours: data.new_truck_hours,
                officeHours: data.office_hrs,
                gtps: data.gtps,
                gtpsDriveBy: data.gtps_db,
                gtpsName: data.gtps_name,
                selectedRoadTypes: data.road_type
                  ? data.road_type.map(rt => JSON.parse(rt))
                  : null,
                downtimeReason: data.reason_dt,
                partialDowntimeReason: data.reason_dt_part,
                numHoursPartialDowntime: data.hours_dt_partial,
                selectedIssues: data.issues
                  ? data.issues.map(issue => JSON.parse(issue))
                  : null,
                comments: data.comments,
                jdate: data.jdate,
                collectedLocationCountry: data.collected_location_country,
                hotelLocation: data.hotel_location
              }
              // If entry has partial downtime hours, allow that input to be edited
              if (data.hours_dt_partial) {
                this.partialDowntimeHoursDisabled = false
              }
              this.updateEntryID = data.id
              this.downFullDayChange()
              this.partialDowntimeReasonChange()
              this.bgColorChange.backgroundColor = this.editBgColorChange
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    closeDPR() {
      this.formSubmitErrors = []
      this.entryManagerRows = []
      this.submitSuccess = ''
      this.updateSuccessMsg = ''
      this.formDisabledControl = false
      this.partialDowntimeHoursDisabled = true
      this.reasonDownFullDayInputDisabled = false
      this.reasonPartialDowntimeInputDisabled = false
      this.vehicles = []
      this.operators = []
      this.roadTypes = []
      this.addDriverBtnDisabled = false
      this.operatorInputs = ['1']
      this.updateEntryID = null
      this.numDriversError = ''
      this.jdate = null
      this.selectedFile = null
      this.entryFreshlyLoaded = false
      this.clearForm()
      this.$bvModal.hide('DPRModal')
    },
    calculateJday() {
      if (this.form.date != null) {
        let jday = new Date(this.form.date)
        let start = new Date(jday.getFullYear(), 0, 0)
        let diff =
          jday -
          start +
          (start.getTimezoneOffset() - jday.getTimezoneOffset()) * 60000
        //  86400000 = number of milliseconds per day
        jday = Math.floor(diff / 86400000) + 1
        this.form.jdate =
          new Date(this.form.date).getFullYear().toString().substr(-2) +
          ('000' + jday).slice(-3)
        this.jdate =
          new Date(this.form.date).getFullYear().toString().substr(-2) +
          ('000' + jday).slice(-3)
      }
    },
    getLocationOptions() {
      let retVal = null

      switch (this.form.collectedLocationCountry) {
        case 'United States of America':
          retVal = this.possibleLocationsUSA
          break
        case 'Canada':
          retVal = this.possibleLocationsCA
          break
      }

      return retVal
    },
    onImageSelected(e) {
      if (e.target.files.length > 3) {
        e.target.value = ''
        this.$bvToast.toast(
          'Error: Maximum of 3 images are allowed per entry',
          {
            autoHideDelay: 7000,
            title: 'Image Count Overflow',
            toaster: 'b-toaster-top-right'
          }
        )
      } else {
        for (let i = 0; i < e.target.files.length; i++) {
          const extension = e.target.files[i].name.split('.').pop()
          const allowedExtensions = ['jpg', 'jpeg', 'png']
          if (!allowedExtensions.includes(extension)) {
            e.target.value = ''
            this.$bvToast.toast(
              `Error: Please upload only 'jpg', 'jpeg', 'png' files .`,
              {
                autoHideDelay: 7000,
                title: 'Invalid file type for image number' + i + '.',
                toaster: 'b-toaster-top-right'
              }
            )
          }
          if (e.target.value != '' && e.target.files[i].size > 15 * 1000000) {
            e.target.value = ''
            this.$bvToast.toast(
              'Error: Image size should not exceed than 15 Mb for image number' +
                i +
                '.',
              {
                autoHideDelay: 7000,
                title: 'Image size Overflow',
                toaster: 'b-toaster-top-right'
              }
            )
          }
          if (sessionStorage.token) {
            if (e.target.value != '') {
              axios
              .get(process.env.API_LOCATION + '/api/dpr/checkDuplicateImage', {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  image_path: 'dpr_uploads\\' + this.$refs.file.files[i].name,
                  user_id: this.user.id
                }
              })
              .then(response => {
                if (response.data > 0) {
                  this.$bvToast.toast(
                    'Error: ' +
                      this.$refs.file.files[i].name +
                      ' is already uploaded .',
                    {
                      autoHideDelay: 7000,
                      title: 'Duplicate Image Upload',
                      toaster: 'b-toaster-top-right'
                    }
                  )
                  this.$refs.file.value = ''
                }
              })
              .catch(function (error) {
                console.log(error)
              })
            }
          } else {
            console.log('No User Token')
          }
        }
      }
    },
    imageUpload() {
      if (this.$refs.file.files[0] != null) {
        //15 mega bytes validations and save file size in database
        for (let i = 0; i < this.$refs.file.files.length; i++) {
          this.selectedFile = this.$refs.file.files[i]
          const formdata = new fd()
          formdata.append('image', this.selectedFile)
          if (sessionStorage.token) {
           axios
            .post(process.env.API_LOCATION + '/api/dpr/uploadImage', formdata, {
              headers: {
                'x-auth-token': sessionStorage.token,
                'Content-Type': 'multipart/form-data; boundary=AaB03x;'
              }
            })
            .then(response => {
              axios
                .get(
                  process.env.API_LOCATION + '/api/dpr/insertDprImageDetails',
                  {
                    headers: {
                      'x-auth-token': sessionStorage.token
                    },
                    params: {
                      dpr_id: this.updateEntryID,
                      image_path: response.data.path,
                      size: this.formatBytes(response.data.size),
                      user_id: this.user.id
                    }
                  }
                )
                .catch(function (error) {
                  console.log(error)
                })
            })
            .catch(function (error) {
              console.log(error)
            })
          } else {
            console.log('No User Token')
          }
        }
      }
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },
    getImageList() {
      if (sessionStorage.token) {
        if (this.user.id && this.updateEntryID) {
          axios
          .get(process.env.API_LOCATION + '/api/dpr/getImageList', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              user_id: this.user.id,
              dpr_id: this.updateEntryID
            }
          })
          .then(response => {
            this.images = response.data.rows
          })
          .catch(function (error) {
            console.log(error)
          })
        }
      } else {
        console.log('No User Token')
      }
    }
  },
  watch: {
    'form.collectedLocationCountry': function (newValue, oldValue) {
      if (this.entryFreshlyLoaded) {
        // If the entry just loaded in, don't clear form.collectedLocation
        this.entryFreshlyLoaded = false
      } else {
        this.form.collectedLocation = []
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
